<template class="whform">
  <div class="page_chili">
    <div style="width: 100%" align="right">
      <el-radio v-model="Page2Type" label="Month" @change="handleUserList"
        >月</el-radio
      >
      <el-radio v-model="Page2Type" label="Year" @change="handleUserList"
        >年</el-radio
      >
      <el-date-picker
        v-model="value1"
        type="month"
        @change="handleUserList"
        value-format="yyyy-MM"
        placeholder="选择日期"
      ></el-date-picker>
    </div>
    <el-row class="whform">
      <el-col :span="17">
        <el-row style="text-align: center">
          <span>金桥变压器综合评价</span>
          <span></span>
        </el-row>
        <div class="whform" style="height: 800px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="userList1.length"
          ></el-pagination>
          <el-table
            :data="
              userList1.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )
            "
            style="
              font-size: 10px;
              width: 100%;
              padding: 0;
              text-algin: center;
              height: 100%;
            "
          >
            <el-table-column
              prop="Plan"
              label="设备"
              style="width: 4%"
            ></el-table-column>
            <el-table-column
              prop="Num"
              label="设备编号"
              style="width: 4%"
            ></el-table-column>
            <el-table-column prop="RatedU1,RatedU2" label="电压等级KV">
              <template slot-scope="scope">
                U1:{{ scope.row.RatedU1 }}
                <br />
                U2:{{ scope.row.RatedU2 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="Mah"
              label="	额定容量kVA"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="CumulativePower"
              label="	累计电量kWh"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="LoadRateInterval"
              label="	负载率区间(%)"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="LoadRate"
              label="	平均负载率(%)"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="IRate"
              label="	平均电流不平衡率(%)"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="VRate"
              label="	平均电压不平衡率(%)"
              style="width: 7%"
            ></el-table-column>
            <el-table-column
              prop="VPassRate"
              label="	电压合格率(%)"
              style="width: 7%"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="7" style="height: 100%">
        <br />
        <br />
        <br />
        <div class="whform">
          <div id="main" style="width: 500px; height: 320px"></div>
        </div>
        <div style="width: 100%; height: 100%; backgroup: #fff;padding:5px">
          <el-table :data="tableData" style="width: 100%;font-size: 4px;padding:0px">
            <el-table-column prop="Type" label="类型" min-width="15%"> </el-table-column>
            <el-table-column prop="setOption1" label="1分" style="padding:0px"  min-width="15%"> </el-table-column>
            <el-table-column prop="setOption2" label="2分" style="padding:0px"  min-width="15%"> </el-table-column>
            <el-table-column prop="setOption3" label="3分" style="padding:0px"  min-width="15%"> </el-table-column>
            <el-table-column prop="setOption4" label="4分" style="padding:0px"  min-width="15%"> </el-table-column>
            <el-table-column prop="setOption5" label="5分" style="padding:0px"  min-width="15%"> </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script lang="ts">
import echarts from "echarts";
import request from "../../utils/request";
import qs from 'qs'
export default {
  //   components: {
  //  vstar,
  // },
  name: "hello",
  data() {
    return {
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      userList1: [],
      LDList: [],
      Page2Type: "Month",
      value1: new Date(),
      msg: "Welcome to Your Vue.js App",
      tableData4: [],
      tableData: [
        {
          Type: "Cos",
          setOption1: "0.91<x<0.92",
          setOption2: "0.92<x<0.93",
          setOption3: "0.93<x<0.94",
          setOption4: "0.94<x<9.95",
          setOption5: "0.95<x",
        },
        {
          Type: "电流不平衡度",
          setOption1: "6%<x<8%",
          setOption2: "4%<x<6%",
          setOption3: "2%<x<4%",
          setOption4: "1%<x<2%",
          setOption5: "x<1%",
        },
        {
          Type: "负载率",
          setOption1: "x<25%,x>90%",
          setOption2: "x<30%,x>85%",
          setOption3: "x<35%,x>80%",
          setOption4: "x<40%,x>70%",
          setOption5: "x>40%,x<70%",
        },
        {
          Type: "电压不平衡率",
          setOption1: "1.6%<x<2%",
          setOption2: "1.2%<x<1.6%",
          setOption3: "0.8%<x<1.2%",
          setOption4: "0.5%<x<0.89%",
          setOption5: "x<0.5%",
        },
      ],
    };
  },
  // mounted() {
  //   this.drawLine();
  // },
  methods: {
    drawLine(va) {
      // 基于准备好的dom，初始化echarts实例
      var chart1 = echarts.init(document.getElementById("main"));
      var option = {
        title: {
          color: "#fff",
          text: "变压器运行评价雷达图",
          textStyle: {
            fontWeight: "normal", //标题颜色
            color: "#FFF",
          },
        },
        tooltip: {},
        legend: {
          data: ["预算分配", "实际开销"],
        },
        grid: {
          x: 25,
          y: 45,
          x2: 5,
          y2: 20,
          borderWidth: 1,
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#999",
              borderRadius: 3,
              padding: [3, 5],
            },
          },
          indicator: [
            { name: "综合评价", max: 5 },
            { name: "负载率", max: 5 },
            { name: "电流不平衡", max: 5 },
            { name: "电压不平衡", max: 5 },
            { name: "电压合格率", max: 5 },
            { name: "功率因数", max: 5 },
          ],
        },
        series: [
          {
            name: "预算 vs 开销（Budget vs spending）",
            type: "radar",
            // areaStyle: {normal: {}},
            data: va,
          },
        ],
      };
      // 绘制图表
      chart1.setOption(option);
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
    },
    handleUserList() {
      var that = this;
      console.log(this.value1);
      console.log(this.Page2Type);
      var sizeForm = {
        NowDataTime: new Date(this.value1+"-01"),
        Type: this.Page2Type,
      };
      request({
        url: "MeterTrans/GetPage2Data",
        method: "post",
        data: sizeForm,
      }).then((response) => {
        that.userList1 = response.data.rs;
        that.LDList = response.data.P2Rt;
        that.drawLine(that.LDList);
      });
    },
  },
  created() {
    this.handleUserList();
  },
};
</script>
<style scoped>
.tableTitle {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 16px;
  color: rgba(101, 101, 101, 1);
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
}
.verticalBar {
  width: 1px;
  height: 100%;
  background: #d4d4d4;
  display: inline-block;
  margin-top: 31px;
  vertical-align: top;
  margin-right: 29px;
  margin-left: 30px;
}
.h4title {
  font-family: "微软雅黑";
  margin: 0;
  padding: 10px 0 0px 0;
  line-height: 30px;
  font-size: 17px;
  font-weight: bold;
  color: #09f;
}
.whform {
  width: 100%;
  height: 100%;
}
</style>